import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  button: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 6,
    boxShadow: 'none',
    height: '25px',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  }
}))
